/**
 * A series of animation or slot definitions for the PayTable Spine
 */
export class PayTableSpineRegister {
    constructor() { }
    static getPrizeExceededAnimation(cellIndex) {
        return [cellIndex, `level-${cellIndex}/passed-set`];
    }
    static getPreviousUnhighlightAnimation(cellIndex) {
        return [cellIndex, `level-${cellIndex}/passed`];
    }
    static getCurrentHighlightAnimation(cellIndex) {
        return [cellIndex, `level-${cellIndex}/active`];
    }
    static getPrizeUnreachedAnimation(cellIndex) {
        return [cellIndex, `level-${cellIndex}/inactive-set`];
    }
    static getAvailableWinAnimation(cellIndex) {
        return [cellIndex, `level-${cellIndex}/highlight`];
    }
    static getUnreachedValueSlot(cellIndex) {
        return `dynamic-value-${cellIndex}`;
    }
    static getUnreachedLabelSlot(cellIndex) {
        return `dynamic-label-${cellIndex}`;
    }
    static getHighlightedValueSlot(cellIndex) {
        return `dynamic-value-${cellIndex}`;
    }
    static getHighlightedLabelSlot(cellIndex) {
        return `dynamic-label-${cellIndex}`;
    }
    static getExceededValueSlot(cellIndex) {
        return `dynamic-value-${cellIndex}`;
    }
    static getExceededLabelSlot(cellIndex) {
        return `dynamic-label-${cellIndex}`;
    }
    static getLabelSlotForState(state, cellIndex) {
        return `dynamic-label-${cellIndex}`;
    }
    static getValueSlotForState(state, cellIndex) {
        return `dynamic-value-${cellIndex}`;
    }
}
//# sourceMappingURL=PayTableSpineRegister.js.map